import { Alert } from "@trussworks/react-uswds";
import { useEffect, useState } from "react";
import { postContactForm } from "utils/fetchers/postContactForm";
import * as yup from "yup";
import { Form, Input, Select, Textarea } from "components/Form";
import { scrollToTop } from "utils";
import { useTranslations } from "use-intl";
import { contactSchema } from "utils/validationSchema";
import { useBypass } from "hooks";
export function ContactForm({
  isTester,
  recaptchaSiteKey
}) {
  const t = useTranslations("Contact");
  const s = useTranslations("Shared");
  if (typeof s.raw("yup") !== "undefined") {
    yup.setLocale(s.raw("yup"));
  }
  const [submitted, setSubmitted] = useState(false);
  const [generalError, setGeneralError] = useState(false);
  const [captchaError, setCaptchaError] = useState(false);
  const [loading, setLoading] = useState(false);
  const {
    schema,
    bypassInput
  } = useBypass({
    schema: contactSchema(s, t),
    isTester
  });
  useEffect(() => {
    setSubmitted(false);
    setGeneralError(false);
    setCaptchaError(false);
    setLoading(false);
  }, []);
  async function onSubmit(values, code) {
    if (!code) {
      return null;
    }
    try {
      setLoading(true);
      const response = await postContactForm({
        form: values,
        code
      });
      if (response === 200) {
        setSubmitted(true);
        setLoading(false);
        scrollToTop();
      } else {
        setCaptchaError(true);
        setSubmitted(false);
        setLoading(false);
        scrollToTop();
      }
    } catch (e) {
      console.error(e);
      setGeneralError(true);
      setLoading(false);
      scrollToTop();
    }
  }
  function renderAlert() {
    if (submitted) {
      return <Alert className="h-28 lg:my-48 order-first lg:order-last" type="success" headingLevel="h2" heading={<h2 className="font-bold">{t("alert.thankyou.heading")}</h2>}>
          {t("alert.thankyou.text")}
        </Alert>;
    } else if (captchaError) {
      return <Alert type="error" className="h-28 order-first lg:order-last" slim>
          {t("alert.captcha_error")}
        </Alert>;
    } else if (generalError) {
      return <Alert type="error" className="h-28 order-first lg:order-last" slim>
          {t("alert.general_error")}
        </Alert>;
    }
    return null;
  }
  if (submitted || captchaError || generalError) {
    return renderAlert();
  }
  return <div className="max-w-prose">
      <>
        {bypassInput}
        <Form onSubmit={onSubmit} schema={schema} loading={loading} recaptchaAction="contact_submit" recaptchaSiteKey={recaptchaSiteKey} className="p-6 lg:py-6 lg:px-8 bg-gray-100  rounded-lg">
          <legend className="text-2xl font-bold mt-2 sr-only">
            {t("legend")}
          </legend>
          <Input name="name" label={t("name")} />
          <Input name="email" label={t("email")} />
          <Input name="confirmEmail" label={t("confirm_email")} />
          <Select label={t("topic")} name="topic" defaultValue="General Feedback" values={["Enhancement Suggestion or Idea", "Report a Bug or Defect", "Other Technical Question"]} options={["enhancement", "bug", "other"]} optionMapper={"topic_"} optionT={t} />
          <Textarea name="message" label={t("message")} />
        </Form>
      </>
    </div>;
}